

import __layout_0 from '/home/vsts/work/1/s/src/layouts/default.vue'
export const layouts = {
'404': () => import('/home/vsts/work/1/s/src/layouts/404.vue'),
'anonymous': () => import('/home/vsts/work/1/s/src/layouts/anonymous.vue'),
'default': __layout_0,
'detail': () => import('/home/vsts/work/1/s/src/layouts/detail.vue'),
'error': () => import('/home/vsts/work/1/s/src/layouts/error.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
